import { NavigateFunction } from "react-router-dom";
import { Action } from "redux";

import { TSingleTestCaseResult } from "@/components/common/RunCode/RunCode.types";
import { EProblemType, IProblem } from "./problems.types";
import { Dictionary } from "./utils.types";

export interface TRunDetails {
  solution_id: number;
  status: string;
  testcases: Dictionary<TSingleTestCaseResult>;
}

export enum ESolutionStatus {
  RUNNING = "RUNNING",
  EVALUATED = "EVALUATED",
  CREATED = "CREATED",
}

export interface ISolution {
  attachments: string[];
  code: string;
  evaluation?: TRunDetails;
  id: number | null;
  is_submitted?: boolean;
  slug?: string;
  status?: ESolutionStatus;
  technology: string;
  codeModifiedAt: Date | undefined;
  languageModifiedAt: Date | undefined;
}

export enum EInterviewProblemType {
  WHITEBOARD = "WHB",
}

export type TQuestionType = EProblemType | EInterviewProblemType;

export interface IQuestion {
  solution: ISolution | null;
  slug: string;
  name: string;
  description: string;
  question_type: TQuestionType;
  source: EQuestionSource;
  tab_index: string;
  problem_slug: string | null;
  problem: IProblem | null;
}

export interface IQuestionsDetails {
  questions: Dictionary<IQuestion>;
  candidateActiveQuestionSlug?: string | null;
}

export interface IQuestionActionType {
  payload: {
    code: string;
    questionSlug: string;
    questions: Dictionary<IQuestion>;
    technology: string;
    solution: ISolution;
    question: IQuestion;
    stub: string;
  };
  type: string;
}

export enum EQuestionSource {
  IMPORTED = "IMPORTED",
  CREATED = "CREATED",
}

export interface IGetAllQuestionsAction extends Action {
  payload: {
    interviewSlug: string;
    navigate?: NavigateFunction;
  };
}

export interface IAddQuestionArgs extends Action {
  payload: {
    questionType: TQuestionType;
    name: string;
    description?: string;
    source: EQuestionSource;
    interviewSlug: string;
    problemSlug?: string;
    navigate: NavigateFunction;
  };
}

export interface IUpdateQuestionArgs extends Action {
  payload: {
    name?: string;
    description?: string;
    questionSlug: string;
    interviewSlug: string;
    source: EQuestionSource;
    problemSlug?: string;
    questionType?: TQuestionType;
    navigate?: NavigateFunction;
  };
}

export interface IRemoveQuestionArgs extends Action {
  payload: {
    interviewSlug: string;
    questionSlug: string;
    navigate: NavigateFunction;
    redirectQuestionSlug: string | null;
    redirectToLandingPage: boolean;
    isCurrentQuestionRemove: boolean;
  };
}

export interface IAddQuestionPayload {
  description?: string;
  name: string;
  question_type: TQuestionType;
  source: EQuestionSource;
  tab_index: number;
  problem_slug?: string;
}

export type TUpdateQuestionPayload =
  | IAddQuestionPayload
  | {
      description?: string;
      name?: string;
    };
